import { IconButton } from '~/components/ui/IconButton';
import { classNames } from '~/utils/classNames';

interface PanelButtonProps {
  icon?: React.ReactNode;
  text?: string;
  isDisabled?: boolean;
  onClick?: () => void;
  isLoading?: boolean;
  title?: string;
  onMouseEnter?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onMouseLeave?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export function PanelButton({
  icon,
  text,
  isDisabled,
  onClick,
  isLoading,
  title,
  ...props
}: PanelButtonProps): JSX.Element {
  return (
    <IconButton
      disabled={isDisabled}
      onClick={onClick}
      aria-label={title}
      aria-describedby={title}
      title={title}
      className={classNames(
        'flex items-center gap-2 bg-zinc-800 text-gray-300 hover:bg-zinc-700',
        'hover:bg-alpha-elements-background-depth-3',
        'h-[33px] px-3 py-5 rounded-md text-sm font-medium transition-all duration-200',
      )}
      {...props}
    >
      {isLoading ? (
        <div className="i-svg-spinners:90-ring-with-bg text-alpha-elements-loader-progress text-xl" />
      ) : (
        <>
          {icon && <div className="text-xl">{icon}</div>}
          {text && <span>{text}</span>}
        </>
      )}
    </IconButton>
  );
}
